import { render } from "./QuizCardModal.vue?vue&type=template&id=48ed92b0&scoped=true&ts=true"
import script from "./QuizCardModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizCardModal.vue?vue&type=script&setup=true&lang=ts"

import "./QuizCardModal.vue?vue&type=style&index=0&id=48ed92b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48ed92b0"],['__file',"src/components/QuizCardModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48ed92b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48ed92b0', __exports__)) {
    api.reload('48ed92b0', __exports__)
  }
  
  module.hot.accept("./QuizCardModal.vue?vue&type=template&id=48ed92b0&scoped=true&ts=true", () => {
    api.rerender('48ed92b0', render)
  })

}


export default __exports__